<template>
  <CFooter :fixed="false">
    <div>
      <span class="ml-1">&copy; 2022 ISIKULKAS.</span>
    </div>
    <div class="mfs-auto">
      <span class="mr-1" target="_blank">Powered by</span>
      <a href="https://isikulkas.co.id">ISIKULKAS</a>
    </div>
  </CFooter>
</template>

<script>
export default {
  name: 'TheFooter'
}
</script>
